/* eslint-disable no-undef */
import React, { useContext } from 'react';
import CurrentUserContext from '../../contexts/CurrentUserContext';
import ImpersonatorContext from '../../contexts/ImpersonatorContext';

export const useIsCurrentUserFleetOpsStaff = () => {
  const { impersonatorId } = useContext(ImpersonatorContext);
  const { isFleetOpsStaff } = useContext(CurrentUserContext);

  return isFleetOpsStaff && impersonatorId === undefined;
};

const FleetOpsStaffOnly = ({
  children,
  fallback,
}: {
  children: JSX.Element | JSX.Element[];
  fallback?: JSX.Element | JSX.Element[];
}) => {
  const isFleetOpsStaff = useIsCurrentUserFleetOpsStaff();

  if (isFleetOpsStaff) {
    return <React.Fragment>{children}</React.Fragment>;
  } else if (fallback) {
    return <>{fallback}</>;
  } else {
    return null;
  }
};

export default FleetOpsStaffOnly;
